module.exports = __webpack_public_path__ + "static/media/iv_free_demat.dc209a70.svg";